import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import Button from '../../../../components/forms/Button'
import Select from '../../../../components/forms/Select'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import NumberField from '../../../../components/forms/NumberField'
import Checkbox from '../../../../components/forms/Checkbox'
import { hasValue } from '../../../../utils/NumberUtil'
import Input from '../../../../components/forms/Input'
import PropTypes from 'prop-types'
import { getSandreList, removeNullKeys } from '../../../../utils/StoreUtils'
import { getDate, getDateWithHour, getHour } from '../../../../utils/DateUtil'
import HydrometryAction from '../../../actions/HydrometryAction'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import { isNull, isUndefined, last, maxBy, template, groupBy, flatMap } from 'lodash'
import DtoHydroMeasure from '../../../dto/chronicMeasures/DtoHydroMeasure'
import { CardTitle } from '../../../../components/card/NewCard'
import { HISTORIC, MOVING, NEWPOINT, POINT, VALIDATION, WINDOW } from '../../../constants/HydrometryConstants'
import ToastrAction from '../../../../toastr/actions/ToastrAction'
import MultiContributorsAutocomplete
    from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import DescriptionMeasure from '../validationUtils/DescriptionMeasure'
import useLocalStorage from '../../../../utils/customHook/useLocalStorage'
import useApplicationSetting from '../../../../utils/customHook/useApplicationSetting'
import { onChangeDate, onChangeHour, setMessageModal } from '../../../../utils/FormUtils'
import { StyledFieldSet, StyledLegend } from '../../../../components/StyledElements'
import { Card, CardContent, Grid } from '@mui/material'
import moment from 'moment/moment'
import { measureHydroType, validationSelectFiltersType } from '../../../shapes/HydroShapes'
import ValidationSeeMoreCriterias from '../validationUtils/ValidationSeeMoreCriterias'
import { IS_INITIAL_POINT, IS_NOT_INITIAL_POINT } from 'station/constants/StationConstants'
import DataTypeSelectionDialog from 'piezometry/components/validation/tools/DataTypeSelectionDialog'
import { getNGFDepthAtDate } from '../../../../utils/HydroUtils'

const ValidationHydroToolPanel = ({
    selection,
    setSelection,
    setSelectionData,
    dates,
    value,
    setValue,
    initialPoint,
    setInitialPoint,
    setStartDate,
    setEndDate,
    setIsChange,
    isChange,
    createTechnicalEvent,
    setIsPreview,
    isPreview,
    hydroMeasuresFormat,
    setMeasuresChangesValidation,
    measuresChangesValidation,
    measuresSelectedByFilters,
    filterFullDay,
    displayModes,
    dataType,
    selectedCodePoint,
    setSelectedCodePoint,
    selectFilters,
    changeSelectFilters,
    useNGF = false,
    landmarkValue,
}) => {
    const dispatch = useDispatch()
    const [subTool, setSubTool] = useState(VALIDATION)

    const [validationFilter, setValidationFilter] = useLocalStorage('HYDRO_VALIDATION_FILTERS', {})
    const {
        status: defaultStatus,
        qualification: defaultQualification,
        nature: defaultNature,
        producer: defaultProducer,
        manager: defaultManager,
        validator: defaultValidator,
        emptyFieldsDontClear: defaultEmptyFieldsDontClear,
    } = validationFilter

    const [status, setStatus] = useState(defaultStatus || undefined)
    const [qualification, setQualification] = useState(defaultQualification || undefined)
    const [nature, setNature] = useState(defaultNature || undefined)
    const [emptyFieldsDontClear, setEmptyFieldsDontClear] = useState(defaultEmptyFieldsDontClear || false)

    const applicationSettingsDefaultProducer = useApplicationSetting('validationDefaultProducerHydro', setting => setting ? parseInt(setting) : undefined)
    const applicationSettingsDefaultManager = useApplicationSetting('validationDefaultManagerHydro', setting => setting ? parseInt(setting) : undefined)
    const applicationSettingsDefaultValidator = useApplicationSetting('validationDefaultValidatorHydro', setting => setting ? parseInt(setting) : undefined)
    const [producer, setProducer] = useState(defaultProducer || applicationSettingsDefaultProducer || undefined)
    const [manager, setManager] = useState(defaultManager || applicationSettingsDefaultManager || undefined)
    const [validator, setValidator] = useState(defaultValidator || applicationSettingsDefaultValidator || undefined)

    const {
        sandreCodes,
        contributors,
        hydrometricStation,
        hydrometryDataTypes,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contributors: store.ContributorReducer.contributors,
        hydrometricStation: store.HydrometryReducer.hydrometricStation,
        hydrometryDataTypes: store.HydrometryReducer.hydrometryDataTypes,
    }), shallowEqual)


    useEffect(() => {
        setValidationFilter(changes => ({ ...changes, status, qualification, nature, producer, manager, validator, emptyFieldsDontClear }))
    }, [status, qualification, nature, producer, manager, validator, emptyFieldsDontClear])

    const [dataTypeDialogOpen, setDataTypeDialogOpen] = useState(false)

    const isRangeValidation = () => selection === WINDOW || selection === HISTORIC

    const getAvailableValidationItems = () => {
        const linkPointPrels = hydrometricStation?.link_pointPrels || []
        return flatMap(groupBy(linkPointPrels, 'typeId'), (points, typeIdStr) => {
            const typeId = parseInt(typeIdStr)
            const typeLabel = hydrometryDataTypes.find(dt => dt.id === typeId)?.label
            if (!typeLabel) return []
            return points.length === 1
                ? [{ key: `${typeId}|${points[0].point}`, label: typeLabel }]
                : points.map(p => ({
                    key: `${typeId}|${p.point}`,
                    label: `${typeLabel} - ${p.name || p.code || p.point}`,
                }))
        })
    }

    const buildValidationPayload = (typeCodepoints) => ({
        typeCodepoints,
        start: dates.startDate,
        end: dates.endDate,
        filters: {
            status: selectFilters?.filterStatus,
            qualification: selectFilters?.filterQualification,
            valueSup: selectFilters?.filterSuperior,
            valueInf: selectFilters?.filterInferior,
            producer: selectFilters?.filterProducer,
            manager: selectFilters?.filterManager,
            validator: selectFilters?.filterValidator,
        },
        set: {
            status,
            qualification,
            nature,
            initialPoint,
            producer,
            manager,
            validator,
        },
        emptyFieldsDontClear: !!emptyFieldsDontClear,
    })

    const onConfirmDataTypes = (selectedKeys) => {
        const typeCodepoints = selectedKeys.map(key => {
            const [typeId, codepoint] = key.split('|').map(Number)
            return { typeId, codepoint }
        })
        setDataTypeDialogOpen(false)
        dispatch(HydrometryAction.validateHydroMeasures(hydrometricStation.id, buildValidationPayload(typeCodepoints), () => {
            setIsPreview(false)
            setIsChange(!isChange)
        }))
    }

    const onCancel = () => {
        setIsPreview(false)
    }

    const onSave = () => {
        if (!(displayModes.brute || displayModes.min || displayModes.max || displayModes.average)) {
            setMessageModal(i18n.validationBruteMessage)
            return
        }
        if (isRangeValidation()) {
            const items = getAvailableValidationItems()
            if (items.length === 1) {
                onConfirmDataTypes([items[0].key])
            } else {
                setDataTypeDialogOpen(true)
            }
            return
        }
        if (selection === NEWPOINT && !selectedCodePoint) { // ajout d'un nouveau point par défaut
            const newPoint = (maxBy(hydrometricStation.link_pointPrels, 'point')?.point ?? 0) + 1
            dispatch(HydrometryAction.updateHydrometer({
                ...hydrometricStation,
                link_pointPrels: [ ...(hydrometricStation.link_pointPrels ?? []), {
                    idStation: hydrometricStation.id,
                    point: newPoint,
                    typeId: dataType,
                    name: `Point ${hydrometryDataTypes.find(dt => dt.id === dataType)?.label ?? ''}`,
                    code: newPoint.toString(),
                    typePoint: 1, // StationPointPrelPanel --> pointTypes -->  { code: 1, name: i18n.pointPrincipal }
                }],
            })).then(() => {
                setSelectedCodePoint(newPoint)
                dispatch(HydrometryAction.fetchHydroStatistics(hydrometricStation.id))
                createTechnicalEvent({ mode: 'validation' })
                setIsPreview(false)
                dispatch(HydrometryAction.updateMeasures(measuresChangesValidation.map(m => ({ ...m, codepoint: newPoint })))).then(() => setIsChange(!isChange))
            })
        } else {
            createTechnicalEvent({ mode: 'validation' })
            setIsPreview(false)
            dispatch(HydrometryAction.updateMeasures(measuresChangesValidation)).then(() => setIsChange(!isChange))
        }
    }

    const onApply = () => {
        if (!displayModes.brute) {
            setMessageModal(i18n.validationBruteMessage)
        } else if (selection === NEWPOINT) {
            if (isNull(dates.startDate) || isUndefined(dates.startDate)) {
                dispatch(ToastrAction.warning(i18n.dateNoSelected))
            } else if (isUndefined(value)) {
                dispatch(ToastrAction.warning(template(i18n.fieldNotSet)({ field: i18n.value })))
            } else {
                const landmark = useNGF ? (getNGFDepthAtDate(hydrometricStation, dates.startDate) ?? landmarkValue) : 0
                const newMeasure = {
                    date: dates.startDate,
                    value: value - landmark,
                    status,
                    qualification,
                    nature,
                    producer,
                    manager,
                    validator,
                    initialPoint,
                    hydroId: hydrometricStation.id,
                    isNew: true,
                    updated: true,
                    dataType,
                    // value: valueWithCompensation,
                    codepoint: selectedCodePoint,
                }
                setMeasuresChangesValidation([newMeasure])
                setIsPreview(true)
            }
        } else if (isNull(dates.startDate) || isNull(dates.endDate) || isUndefined(dates.startDate) || isUndefined(dates.endDate)) {
            if (selection === POINT) {
                dispatch(ToastrAction.warning(i18n.dateNoSelected))
            } else {
                dispatch(ToastrAction.warning(i18n.datesNoSelected))
            }
        } else {
            const filterFields = emptyFieldsDontClear ? removeNullKeys : obj => obj
            const obj = filterFields({ status, qualification, producer, manager, nature, validator, initialPoint })

            const measuresToUpdate = measuresSelectedByFilters.map(m => ({
                ...m,
                ...obj,
                value: [POINT, MOVING, NEWPOINT].includes(selection) ? value : m.value,
                updated: true,
            }))
            setMeasuresChangesValidation(measuresToUpdate)
            setIsPreview(true)
        }
    }

    const selectHisto = () => {
        const m = hydroMeasuresFormat
        setStartDate(m[0].date)
        setEndDate(last(m).date)
    }


    const point = selection === POINT || selection === MOVING && dates.startDate ? hydroMeasuresFormat.find(m => m.date === dates.startDate) : null
    const disabled = { disabled: (selection !== POINT && isPreview) || filterFullDay.validationFilterFullDay }
    const resetToolValues = () => {
        setStartDate(null)
        setEndDate(null)
    }

    const measureStartDate = hydroMeasuresFormat.find(p => p.date === dates.startDate)


    return (
        <Card>
            <CardTitle title={i18n.validation} />
            <CardContent>
                <div className='padding-top-1' id='validationToolPanel'/>
                <Grid container justifyContent='center' sx={ { paddingBottom: '10px' } }>
                    <Button
                        tooltip={ i18n.selectRange }
                        className={ `validToolBtn margin-right-1 ${subTool === VALIDATION && selection === WINDOW ? 'activated' : ''}` }
                        onClick={ () => {
                            // this.props.changeParent({ selectionMode: 'start', startDate: null, endDate: null, draggable: false, selectedPoint: null })
                            setSubTool(VALIDATION)
                            setSelection(WINDOW)
                            resetToolValues()
                            setSelectionData('end')
                        } }
                        icon='settings_ethernet'
                        {...disabled}
                    />
                    <Button
                        tooltip={ i18n.selectHistory }
                        className={ `validToolBtn margin-right-1 ${subTool === VALIDATION && selection === HISTORIC ? 'activated' : ''}` }
                        onClick={ () => {
                            // his.props.changeParent({ draggable: false, selectionMode: null, selectedPoint: null })
                            setSubTool(VALIDATION)
                            setSelection((HISTORIC))
                            resetToolValues()
                            selectHisto()
                        } }
                        icon='insert_chart'
                        {...disabled}
                    />
                    <Button
                        tooltip={ i18n.selectMeasure }
                        className={ `validToolBtn margin-right-1 ${subTool === VALIDATION && selection === POINT ? 'activated' : ''}` }
                        onClick={ () => {
                            // this.props.changeParent({ selectionMode: 'point', startDate: null, endDate: null, draggable: false, selectedPoint: null })
                            setSubTool(VALIDATION)
                            setSelection(POINT)
                            resetToolValues()
                        }}
                        icon='edit_location'
                        {...disabled}
                    />
                    <Button
                        tooltip={i18n.addMeasure}
                        onClick={() => {
                            const lastMeasure = last(hydroMeasuresFormat)
                            const newDate = lastMeasure ? moment(lastMeasure.date).add(1, 'day').valueOf() : undefined
                            // this.props.changeParent({ selectionMode: null, startDate: newDate, endDate: newDate, draggable: false, selectedPoint: null })
                            // this.setState({ subTool: 'newPoint', selection: 'newPoint', initialPoint: null, value: null })
                            setSubTool(NEWPOINT)
                            setSelection(NEWPOINT)
                            setStartDate(newDate)
                        }}
                        icon='add'
                        className={`validToolBtn margin-right-1 ${subTool === NEWPOINT ? 'activated' : ''}`}
                        {...disabled}
                    />
                </Grid>
                <Grid container sx={{ paddingLeft: '10px' }}>
                    <Checkbox
                        checked={filterFullDay.validationFilterFullDay}
                        onChange={() => {
                            filterFullDay.setValidationFilterFullDay(prev => !prev)
                        }}
                        label={i18n.validateFullDay}
                        disabled={selection !== POINT && isPreview}
                    />
                </Grid>
                <StyledFieldSet style={{ margin: '10px', backgroundColor: '#d9dfe4' }}>
                    <StyledLegend>{i18n.selectionCriteria}</StyledLegend>
                    <Grid sx={{ paddingLeft: '10px', fontWeight: 'bold', paddingBottom: '10px' }}>{ measuresSelectedByFilters.length } { measuresSelectedByFilters.length > 1 ? i18n.selectedMeasures : i18n.selectedMeasure }</Grid>
                    <Grid container spacing={3}>
                        <Grid size={6}>
                            <Input
                                title={ [WINDOW, HISTORIC].includes(selection) ? i18n.startDate : i18n.date }
                                id='startDate'
                                value={ getDate(dates.startDate)}
                                onChange={ v => {
                                    onChangeDate(v, v2 => {
                                        return setStartDate(getDateWithHour(v2, dates.startDate)?.valueOf())
                                    })
                                } }
                                disabled={ isPreview || (filterFullDay.validationFilterFullDay) }
                            />
                        </Grid>
                        <Grid size={6}>
                            <Input
                                id='startDateHour'
                                title={ [WINDOW, HISTORIC].includes(selection) ? i18n.startHour : i18n.hour }
                                value={ getHour(dates.startDate) }
                                onChange={ v => {
                                    onChangeHour(v, v2 => {
                                        return setStartDate(getDateWithHour(dates.startDate, v2).valueOf())
                                    })
                                } }
                                disabled={ isPreview || (filterFullDay.validationFilterFullDay) }
                            />
                        </Grid>
                    </Grid>
                    {
                        [WINDOW, HISTORIC].includes(selection) && (
                            <Grid container spacing={3}>
                                <Grid size={6}>
                                    <Input
                                        id='endDate'
                                        value={ getDate(dates.endDate) }
                                        title={ i18n.endDate }
                                        onChange={ v => {
                                            onChangeDate(v, v2 => {
                                                return setEndDate(getDateWithHour(v2, dates.endDate).valueOf())
                                            })
                                        } }
                                        disabled={ isPreview || (filterFullDay.validationFilterFullDay) }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        id='endDateHour'
                                        title={ i18n.endHour }
                                        value={ getHour(dates.endDate) }
                                        onChange={ v => {
                                            onChangeHour(v, v2 => {
                                                return setEndDate(getDateWithHour(dates.endDate, v2).valueOf())
                                            })
                                        } }
                                        disabled={ isPreview || (filterFullDay.validationFilterFullDay) }
                                    />
                                </Grid>
                            </Grid>
                        )
                    }
                    <ValidationSeeMoreCriterias
                        selectFilters={selectFilters}
                        changeSelectFilters={changeSelectFilters}
                        isValidateActive={isPreview}
                    />
                </StyledFieldSet>
                <Grid container spacing={1} sx={{ paddingLeft: '10px', paddingRight: '10px' }}>
                    <Grid size={6}>
                        <Select
                            label={ i18n.status }
                            value={ status }
                            noSort
                            onChange={ setStatus }
                            options={ getStatusSelectOptions() }
                            nullLabel={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                            disabled={ isPreview }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={ i18n.qualification }
                            value={ qualification }
                            noSort
                            onChange={ setQualification }
                            options={ getQualificationSelectOptions() }
                            nullLabel={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                            disabled={ isPreview }
                        />
                    </Grid>
                    <Grid size={6}>
                        <Select
                            label={ i18n.measureNature }
                            value={ nature }
                            onChange={ setNature }
                            options={ getSandreList(sandreCodes, SANDRE.PIEZOMETER_MEASURE_NATURE, true) }
                            nullLabel={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                            disabled={ isPreview }
                        />
                    </Grid>
                    <Grid size={12}>
                        <MultiContributorsAutocomplete
                            label={ i18n.producer }
                            values={ producer }
                            onChange={ setProducer }
                            options={ contributors }
                            disabled={isPreview}
                            placeholder={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            label={ i18n.administrator }
                            values={ manager }
                            onChange={ setManager }
                            options={ contributors }
                            disabled={ isPreview }
                            placeholder={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                        />
                    </Grid>
                    <Grid size={6}>
                        <MultiContributorsAutocomplete
                            label={ i18n.validator }
                            values={ validator }
                            onChange={ setValidator }
                            options={ contributors }
                            disabled={ isPreview }
                            placeholder={ emptyFieldsDontClear ? i18n.unchanged : undefined }
                        />
                    </Grid>
                    <Grid size={12}>
                        <Checkbox
                            checked={emptyFieldsDontClear}
                            onChange={setEmptyFieldsDontClear}
                            label={i18n.emptyFieldsDontClear}
                            disabled={ isPreview }
                        />
                    </Grid>
                </Grid>

                { [POINT, MOVING, NEWPOINT].includes(selection) && (
                    <Grid container alignItems='center' spacing={1} sx={{ paddingLeft: '10px' }}>
                        <Grid size={6}>
                            <NumberField
                                title={ i18n.valueLabel }
                                value={ value }
                                onChange={ setValue }
                                disabled={ isPreview }
                                floatValue
                            />
                        </Grid>
                        <Grid size={6} className='padding-top-1'>
                            <Checkbox
                                label={ i18n.initialPoint }
                                checked={ hasValue(initialPoint) ? initialPoint === IS_INITIAL_POINT : (point && point.initialPoint === IS_INITIAL_POINT) }
                                onChange={ v => setInitialPoint(v ? IS_INITIAL_POINT : IS_NOT_INITIAL_POINT) }
                                disabled={ isPreview }
                            />
                        </Grid>
                    </Grid>
                ) }
                { measureStartDate && (
                    <DescriptionMeasure selection={selection} measure={measureStartDate}/>
                )}

                <Grid container className='padding-1' justifyContent='center'>
                    <Button
                        tooltip={ i18n.apply }
                        onClick={ onApply }
                        icon='border_color'
                        className='btn-floating btn-large'
                        disabled={isPreview}
                    />
                    <Button
                        tooltip={ i18n.cancel }
                        onClick={ onCancel }
                        icon='cancel'
                        className='red btn-floating btn-large margin-left-2 margin-right-2'
                        disabled={ !isPreview }
                    />
                    <Button
                        tooltip={ i18n.register }
                        onClick={ onSave }
                        icon='save'
                        disabled={ !isPreview }
                        className={ `btn-floating btn-large ${isPreview ? 'pulse' : ''}` }
                    />
                </Grid>
                <DataTypeSelectionDialog
                    open={dataTypeDialogOpen}
                    availableItems={getAvailableValidationItems()}
                    defaultSelected={hasValue(dataType) && hasValue(selectedCodePoint) ? [`${dataType}|${selectedCodePoint}`] : []}
                    requiredIds={hasValue(dataType) && hasValue(selectedCodePoint) ? [`${dataType}|${selectedCodePoint}`] : []}
                    onCancel={() => setDataTypeDialogOpen(false)}
                    onValidate={onConfirmDataTypes}
                />
            </CardContent>
        </Card>
    )
}
ValidationHydroToolPanel.propTypes = {
    selection: PropTypes.string,
    setSelection: PropTypes.func,
    setSelectionData: PropTypes.func,
    objetHydroStation: PropTypes.instanceOf(DtoHydroMeasure),
    dates: PropTypes.objectOf(PropTypes.number),
    value: PropTypes.number,
    setValue: PropTypes.func,
    initialPoint: PropTypes.number,
    setInitialPoint: PropTypes.func,
    status: PropTypes.number,
    setStatus: PropTypes.func,
    qualification: PropTypes.number,
    setQualification: PropTypes.func,
    nature: PropTypes.string,
    setNature: PropTypes.func,
    hydroMeasuresFormat: PropTypes.arrayOf(measureHydroType),
    // measureMode,
    // setMeasureMode,
    producer: PropTypes.number,
    setProducer: PropTypes.func,
    manager: PropTypes.number,
    setManager: PropTypes.func,
    validator: PropTypes.number,
    setValidator: PropTypes.func,
    setStartDate: PropTypes.func,
    setEndDate: PropTypes.func,
    setIsChange: PropTypes.func,
    isChange: PropTypes.bool,
    createTechnicalEvent: PropTypes.func,
    setIsPreview: PropTypes.func,
    isPreview: PropTypes.bool,
    setValidationFilter: PropTypes.func,
    setMeasuresChangesValidation: PropTypes.func,
    measuresChangesValidation: PropTypes.arrayOf(measureHydroType),
    measuresSelectedByFilters: PropTypes.arrayOf(measureHydroType),
    dataType: PropTypes.number,
    selectedCodePoint: PropTypes.number,
    setSelectedCodePoint: PropTypes.func,
    filterFullDay: PropTypes.arrayOf(PropTypes.shape({
        validationFilterFullDay: PropTypes.bool,
        setValidationFilterFullDay: PropTypes.func,
    })),
    displayModes: PropTypes.objectOf(PropTypes.bool),
    selectFilters: validationSelectFiltersType,
    changeSelectFilters: PropTypes.func,
    useNGF: PropTypes.bool,
    landmarkValue: PropTypes.number,
}
export default ValidationHydroToolPanel